import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportComponent } from './components/passport/passport.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PassportRoutingModule } from './passport-routing.module';
import { ProfileComponent } from './components/profile/profile.component';
import { StampsBoxComponent } from './components/stamps-box/stamps-box.component';
import { SpotlightEventStampComponent } from './components/spotlight-event-stamp/spotlight-event-stamp.component';
import { DisplayComponent } from './components/profile/display/display.component';
import { EditComponent } from './components/profile/edit/edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupComponent } from './components/popup/popup.component';
import { NgbRatingModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommunityPassportsComponent } from './components/community-passports/community-passports.component';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    PassportComponent,
    CommunityPassportsComponent,
    ProfileComponent,
    StampsBoxComponent,
    SpotlightEventStampComponent,
    DisplayComponent,
    EditComponent,
    PopupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PassportRoutingModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NgbRatingModule,
    NgbTooltipModule,
    NgxSpinnerModule
  ]
})
export class PassportModule { }
